<div class="bg-light h-100 mt-3 pt-2 pb-3 pr-3 pl-3">
  <div *ngIf="!method" class="h-100">
    <h4>Choose a Method of Calculating Ability Scores</h4>
    <div class="d-flex justify-content-between h-100 mt-5">
      <div class="method-card p-2" (click)="calculateAbilities('Standard')">
        <h5>Standard Array</h5>
        <p>The standard array is a specific set of scores, which in D&D 5th edition is [15, 14, 13, 12, 10, 8]. Take
          these scores and assign them to the ability of your choice. This method provides middling scores and a simple
          way to assign ability scores.</p>
      </div>
      <div class="method-card p-2" (click)="calculateAbilities('Discard')">
        <h5>Discard Lowest</h5>
        <p>Roll 4d6 and discard the lowest score. Repeat six times and assign the results to the
          ability scores of your choice. This method tends to produce higher than average scores,
          which is more appropriate for a heroic character.</p>
      </div>
      <div class="method-card p-2" (click)="calculateAbilities('Difficulty')">
        <h5>Point Buy</h5>
        <p>The point buy method is used to purchase ability scores out of a pool of points. The number of
          points available is determined by the DM based on the difficulty of the campaign. This method
          grants the player more freedom to create the type of character they want to run.</p>
      </div>
    </div>
  </div>

  <div *ngIf="method === 'Difficulty'" class="h-100">
    <h4>Choose Difficulty of Campaign</h4>
    <div *ngIf="!pointPool" class="d-flex justify-content-between mt-4">
      <div class="method-card p-2" style="width: 18%" (click)="buy(15)"><h6>Low-powered</h6>Points: 15</div>
      <div class="method-card p-2" style="width: 18%" (click)="buy(22)"><h6>Challenging</h6>Points: 22</div>
      <div class="method-card p-2" style="width: 18%" (click)="buy(25)"><h6>Regular</h6>Points: 25</div>
      <div class="method-card p-2" style="width: 18%" (click)="buy(28)"><h6>Tougher</h6>Points: 28</div>
      <div class="method-card p-2" style="width: 18%" (click)="buy(32)"><h6>High-powered</h6>Points: 32</div>
    </div>
  </div>

  <div *ngIf="method && method !== 'Difficulty'">
    <h4 class="m-0 align-self-end">{{method === 'Buy' ? 'Assign Points From Pool' : 'Drag Desired Roll to Ability'}}</h4>

    <ng-container cdkDropListGroup class="mt-4">
      <div class="d-flex justify-content-around w-50 mx-auto mt-3">
        <div id="str" cdkDropList [cdkDropListData]="str" (cdkDropListDropped)="drop($event)" class="card stat-drop"
             [cdkDropListEnterPredicate]="hasValuePredicate">
          <div class="d-flex justify-content-center w-100 h-25 mt-1 border-bottom">Str</div>
          <div class="text-center">{{str[0]}}</div>
          <div *ngIf="method === 'Buy'" class="d-flex justify-content-between">
            <button (click)="addPointFromPool('str', true)" class="btn btn-sm p-0" type="button"
                    [disabled]="disabled('str', true)">
              <fa-icon [icon]="faCaretUp" class="fa" style="font-size: 1.25em"></fa-icon>
            </button>
            <button (click)="addPointFromPool('str', false)" class="btn btn-sm p-0" type="button"
                    [disabled]="disabled('str', false)">
              <fa-icon [icon]="faCaretDown" class="fa" style="font-size: 1.25em"></fa-icon>
            </button>
          </div>
        </div>
        <div id="dex" cdkDropList [cdkDropListData]="dex" (cdkDropListDropped)="drop($event)" class="card stat-drop"
             [cdkDropListEnterPredicate]="hasValuePredicate">
          <div class="d-flex justify-content-center w-100 h-25 mt-1 border-bottom">Dex</div>
          <div class="text-center">{{dex[0]}}</div>
          <div *ngIf="method === 'Buy'" class="d-flex justify-content-between">
            <button (click)="addPointFromPool('dex', true)" class="btn btn-sm p-0" type="button"
                    [disabled]="disabled('dex', true)">
              <fa-icon [icon]="faCaretUp" class="fa" style="font-size: 1.25em"></fa-icon>
            </button>
            <button (click)="addPointFromPool('dex', false)" class="btn btn-sm p-0" type="button"
                    [disabled]="disabled('dex', false)">
              <fa-icon [icon]="faCaretDown" class="fa" style="font-size: 1.25em"></fa-icon>
            </button>
          </div>
        </div>
        <div id="int" cdkDropList [cdkDropListData]="int" (cdkDropListDropped)="drop($event)" class="card stat-drop"
             [cdkDropListEnterPredicate]="hasValuePredicate">
          <div class="d-flex justify-content-center w-100 h-25 mt-1 border-bottom">Int</div>
          <div class="text-center">{{int[0]}}</div>
          <div *ngIf="method === 'Buy'" class="d-flex justify-content-between">
            <button (click)="addPointFromPool('int', true)" class="btn btn-sm p-0" type="button"
                    [disabled]="disabled('int', true)">
              <fa-icon [icon]="faCaretUp" class="fa" style="font-size: 1.25em"></fa-icon>
            </button>
            <button (click)="addPointFromPool('int', false)" class="btn btn-sm p-0" type="button"
                    [disabled]="disabled('int', false)">
              <fa-icon [icon]="faCaretDown" class="fa" style="font-size: 1.25em"></fa-icon>
            </button>
          </div>
        </div>
        <div id="con" cdkDropList [cdkDropListData]="con" (cdkDropListDropped)="drop($event)" class="card stat-drop"
             [cdkDropListEnterPredicate]="hasValuePredicate">
          <div class="d-flex justify-content-center w-100 h-25 mt-1 border-bottom">Con</div>
          <div class="text-center">{{con[0]}}</div>
          <div *ngIf="method === 'Buy'" class="d-flex justify-content-between">
            <button (click)="addPointFromPool('con', true)" class="btn btn-sm p-0" type="button"
                    [disabled]="disabled('con', true)">
              <fa-icon [icon]="faCaretUp" class="fa" style="font-size: 1.25em"></fa-icon>
            </button>
            <button (click)="addPointFromPool('con', false)" class="btn btn-sm p-0" type="button"
                    [disabled]="disabled('con', false)">
              <fa-icon [icon]="faCaretDown" class="fa" style="font-size: 1.25em"></fa-icon>
            </button>
          </div>
        </div>
        <div id="wis" cdkDropList [cdkDropListData]="wis" (cdkDropListDropped)="drop($event)" class="card stat-drop"
             [cdkDropListEnterPredicate]="hasValuePredicate">
          <div class="d-flex justify-content-center w-100 h-25 mt-1 border-bottom">Wis</div>
          <div class="text-center">{{wis[0]}}</div>
          <div *ngIf="method === 'Buy'" class="d-flex justify-content-between">
            <button (click)="addPointFromPool('wis', true)" class="btn btn-sm p-0" type="button"
                    [disabled]="disabled('wis', true)">
              <fa-icon [icon]="faCaretUp" class="fa" style="font-size: 1.25em"></fa-icon>
            </button>
            <button (click)="addPointFromPool('wis', false)" class="btn btn-sm p-0" type="button"
                    [disabled]="disabled('wis', false)">
              <fa-icon [icon]="faCaretDown" class="fa" style="font-size: 1.25em"></fa-icon>
            </button>
          </div>
        </div>
        <div id="cha" cdkDropList [cdkDropListData]="cha" (cdkDropListDropped)="drop($event)" class="card stat-drop"
             [cdkDropListEnterPredicate]="hasValuePredicate">
          <div class="d-flex justify-content-center w-100 h-25 mt-1 border-bottom">Cha</div>
          <div class="text-center">{{cha[0]}}</div>
          <div *ngIf="method === 'Buy'" class="d-flex justify-content-between">
            <button (click)="addPointFromPool('cha', true)" class="btn btn-sm p-0" type="button"
                    [disabled]="disabled('cha', true)">
              <fa-icon [icon]="faCaretUp" class="fa" style="font-size: 1.25em"></fa-icon>
            </button>
            <button (click)="addPointFromPool('cha', false)" class="btn btn-sm p-0" type="button"
                    [disabled]="disabled('cha', false)">
              <fa-icon [icon]="faCaretDown" class="fa" style="font-size: 1.25em"></fa-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="d-flex w-50 mx-auto mt-2" style="height: 75px">
        <div *ngIf="method === 'Roll' || 'Discard'" cdkDropList [cdkDropListData]="rollList"
             [cdkDropListConnectedTo]="['str', 'dex', 'int', 'con', 'wis', 'cha']"
             class="d-flex justify-content-around mx-auto w-50">
          <div *ngFor="let roll of rollList" cdkDrag class="card roll-drag my-auto">{{roll}}</div>
        </div>
      </div>

      <div *ngIf="method === 'Buy'" class="w-100">
        <div class="card mx-auto text-center" style="width: 15%">
          <div>
            {{pointPool}}
          </div>
          <div>
            Point Pool
          </div>
        </div>
        <table class="mx-auto mt-3">
          <tr>
            <th>Ability Score</th>
            <td *ngFor="let tableAbility of tableAbilities">{{tableAbility}}</td>
          </tr>
          <tr>
            <th>Point Cost</th>
            <td *ngFor="let tablePoint of tablePoints">{{tablePoint}}</td>
          </tr>
        </table>
      </div>
    </ng-container>

    <div class="d-flex justify-content-center w-50 mx-auto mt-2 mb-2">
      <button *ngIf="method === 'Discard'" (click)="discardLowest( 4, 6)" class="btn btn-sm btn-main" type="button">Roll
        Again
      </button>
    </div>
  </div>
</div>
